<template>
  <div id="header">
    <burger-icon :open="menuOpen" :onClick="toggleMenu" class="burger" />

    <div class="profile" v-if="app_user">
      <a class="help" href="https://acada.zendesk.com/" target="_blank"
        ><img src="../assets/icons/help.svg"
      /></a>

      <div class="pic" v-if="app_user.initials">{{ app_user.initials }}</div>
      <!--<div class="pic" style="background-image: url()"></div>-->

      <div class="details">
        <div class="name">{{ app_user.name }}</div>
        <div class="role">{{ app_user.jobTitle }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import BurgerIcon from './BurgerIcon';

export default {
  name: 'Header',
  computed: {
    app_user() {
      return this.$store.getters.app_user;
    },
    logoFile() {
      if (!this.app_user || !this.app_user.organization) return null;

      let url = this.app_user.organization.logoUrl;
      if (!url) return null;

      url = url.replace('.svg', '_black.svg').replace('.png', '_black.png');
      return url;
    },
    menuOpen() {
      return this.$store.getters.burgerMenuOpen;
    },
  },
  methods: {
    goHome() {
      this.$router.replace('/projects');
    },
    toggleMenu() {
      this.$store.dispatch('setBurgerMenuOpen', !this.menuOpen);
    },
  },
  components: {
    'burger-icon': BurgerIcon,
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

#header {
  width: calc(100% - 320px);
  height: 80px;
  padding: 20px 40px;
  background: white;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 320px;
  border-bottom: 1px solid $border-color;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media screen and (max-width: 1430px) {
    left: 0px;
    width: 100%;
    justify-content: space-between;

    .burger {
      display: block !important;
    }
  }

  .burger {
    display: none;
  }

  .profile {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .name {
      font-size: 14px;
      color: black;
      margin: 0;
      margin-bottom: -2px;
    }

    .role {
      font-size: 12px;
      color: #acb6c1;
      margin: 0;
    }

    .pic {
      color: white;
      text-transform: uppercase;
      letter-spacing: 0.6px;
      background-size: cover;
      background-color: $sidebar-color;
      background-position: center center;
      background-repeat: no-repeat;
      border-radius: 50%;
      margin-right: 10px;
      width: 38px;
      height: 38px;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.help {
  margin-right: 30px;
  cursor: pointer;

  &:hover {
    filter: brightness(110%);
  }
}
</style>
